function ElmScroller(args) {
    "use strict";

    this.version = "1.5";
    
    var defargs = {
        window: null,
        document: null,
        element: null,
        elementparent: null,
        direction_x: false,
        direction_y: false,
        resize_timer: null,
        scroll_elmclass: "",
        scroll_elmtimer: null,
        scroll_percentage: 100, // Percentage of element width (0-100%)
        scrollbar_size: getScrollbarWidth()
    };

    $.extend(defargs, args);

    if (defargs.element === null || defargs.elementparent === null || defargs.window === null || defargs.document === null) { throw new Error("Invalid arguments passed to ElmScroller constructor."); }

    var updateScrollButtons = function () {
        var scrollaclass = "";
        var scrollrclass = "";
        
        if (defargs.direction_y) {
            var curposy = Math.ceil($(defargs.element).scrollTop());
            var maxh = Math.ceil($(defargs.element)[0].scrollHeight);
            var h = Math.ceil($(defargs.element).outerHeight());
            var hasscrolly = false;

            if (h < maxh && curposy > 0) {
                $(".scroll-up", defargs.elementparent).css("display", "block");
                hasscrolly = true;
            }
            else {
                $(".scroll-up", defargs.elementparent).css("display", "none");
            }

            if ((curposy + h) < maxh) {
                $(".scroll-down", defargs.elementparent).css("display", "block");
                hasscrolly = true;
            }
            else {
                $(".scroll-down", defargs.elementparent).css("display", "none");
            }

            scrollaclass = "";
            scrollrclass = "";
            
            if (hasscrolly) {
                scrollaclass += " has-scroll-y";
            }
            else {
                scrollrclass += " has-scroll-y";
            }

            if (defargs.scrollbar_size === 0) {
                scrollaclass += " scroll-hidden";
            }
            else {
                scrollrclass += " scroll-hidden";
            }

            $(defargs.elementparent).addClass(scrollaclass);
            $(defargs.elementparent).removeClass(scrollrclass);
        }

        if (defargs.direction_x) {
            var curposx = Math.ceil($(defargs.element).scrollLeft());
            var maxw = Math.ceil($(defargs.element)[0].scrollWidth);
            var w = Math.ceil($(defargs.element).outerWidth());
            var hasscrollx = false;

            if (w < maxw && curposx > 0) {
                $(".scroll-left", defargs.elementparent).css("display", "block");
                hasscrollx = true;
            }
            else {
                $(".scroll-left", defargs.elementparent).css("display", "none");
            }

            if ((curposx + w) < maxw) {
                $(".scroll-right", defargs.elementparent).css("display", "block");
                hasscrollx = true;
            }
            else {
                $(".scroll-right", defargs.elementparent).css("display", "none");
            }
            
            scrollaclass = "";
            scrollrclass = "";
            
            if (hasscrollx) {
                scrollaclass += " has-scroll-x";
            }
            else {
                scrollrclass += " has-scroll-x";
            }

            if (defargs.scrollbar_size === 0) {
                scrollaclass += " scroll-hidden";
            }
            else {
                scrollrclass += " scroll-hidden";
            }

            $(defargs.elementparent).addClass(scrollaclass);
            $(defargs.elementparent).removeClass(scrollrclass);
        }        
    };

    // Export function    
    this.redrawScrollButtons = updateScrollButtons;    

    initialize();    
      
    function initialize() {

        $(defargs.element).addClass("elmscroller-client");

        // Add scroll buttons
        if (defargs.direction_y) {
            $(defargs.elementparent).append("<button type='button' aria-label='Scroll Up' class='scroll-button scroll-up'></button><button type='button' aria-label='Scroll Down' class='scroll-button scroll-down'></button>");

            $(".scroll-up", defargs.elementparent).click(function() {
                var curpos = $(defargs.element).scrollTop();
                var ch = $(defargs.element).outerHeight();
                var dist = ch * (defargs.scroll_percentage / 100);

                if (curpos - dist < 0) { dist = curpos; }

                scrollToPosY(curpos - dist);
            });

            $(".scroll-down", defargs.elementparent).click(function() {
                var curpos = $(defargs.element).scrollTop();
                var maxh = $(defargs.element)[0].scrollHeight;
                var ch = $(defargs.element).outerHeight();
                var dist = ch * (defargs.scroll_percentage / 100);

                if (maxh - (ch + curpos) < dist) { dist = maxh - (ch + curpos); }

                scrollToPosY(curpos + dist);
            });
        }

        if (defargs.direction_x) {
            $(defargs.elementparent).append("<button type='button' aria-label='Scroll Left' class='scroll-button scroll-left'></button><button type='button' aria-label='Scroll Right' class='scroll-button scroll-right'></button>");

            $(".scroll-left", defargs.elementparent).click(function() {
                var curpos = $(defargs.element).scrollLeft();
                var ch = $(defargs.element).outerWidth();
                var dist = ch * (defargs.scroll_percentage / 100);

                if (curpos - dist < 0) { dist = curpos; }

                scrollToPosX(curpos - dist);
            });

            $(".scroll-right", defargs.elementparent).click(function() {
                var curpos = $(defargs.element).scrollLeft();
                var maxw = $(defargs.element)[0].scrollWidth;
                var ch = $(defargs.element).outerWidth();
                var dist = ch * (defargs.scroll_percentage / 100);

                if (maxw - (ch + curpos) < dist) { dist = maxw - (ch + curpos); }

                scrollToPosX(curpos + dist);
            });
        }  
        
        onContainerChange();

        $(defargs.window).resize(function () {
            onContainerChange();

            // Call again after a few milliseconds in case of resize animations            
            if (defargs.resize_timer !== null) {
                clearTimeout(defargs.resize_timer);
            }

            defargs.resize_timer = setTimeout(function () { onContainerChange(); }, 1500);            
        });
               
        $(defargs.element).scroll(function () {
            onContainerChange();
        });                  
    }

    function onContainerChange() {
        updateScrollButtons();
        setScrollElementTimer();        
    }

    function getScrollbarWidth() {
        if (ElmScroller.scrollbar_width === undefined) {
            
            var style = "<style>.elmscroller-client { -ms-overflow-style: none; } .elmscroller-client::-webkit-scrollbar { display: none; }</style>";
            var div = $('<div class="elmscroller-client" style="width:50px;height:50px;overflow-y:scroll;position:absolute;top:-200px;left:-200px;"><div style="height:100px;"></div>');

            // Only add styles once            
            if (ElmScroller.styles_added === undefined || !ElmScroller.styles_added) {
                $('head').append(style);

                ElmScroller.styles_added = true;
            }

            $('body').append(div);

            var ssize = $(div)[0].offsetWidth - $(div)[0].clientWidth;
            $(div).remove();

            ElmScroller.scrollbar_width = ssize;
        }

        return ElmScroller.scrollbar_width;
    }

    function setScrollElementTimer() {
        if (defargs.scroll_elmclass.length > 0) {
            if (defargs.scroll_elmtimer !== null) {
                clearTimeout(defargs.scroll_elmtimer);
            }

            defargs.scroll_elmtimer = setTimeout(function () { centerOnElement(); }, 100);
        }    
    }
    
    function centerOnElement() {
        var curpos = $(defargs.element).scrollLeft();
        var elm = null;
        var diff = -1;

        $(defargs.scroll_elmclass, defargs.element).each(function () {
            var x = $(this).position().left;

            if (curpos - Math.abs(x) >= diff) {
                diff = curpos - Math.abs(x);
                elm = this;
            }
        });

        if (elm !== null) { scrollToPosX(curpos + $(elm).position().left); }
    }

    function scrollToPosY(pos) {
        pos = Math.ceil(pos);
        TweenMax.to(defargs.element, 0.3, { scrollTop: pos, ease: Quad.easeOut, onComplete: function() { updateScrollButtons(); } });
    }

    function scrollToPosX(pos) {
        pos = Math.ceil(pos);
        TweenMax.to(defargs.element, 0.3, { scrollLeft: pos, ease: Quad.easeOut, onComplete: function() { updateScrollButtons(); } });
    }

    this.positionScrollTop = function () {
        $(defargs.element).scrollTop(0);
    };
    
    this.scrollToTop = function () {
        scrollToPosY(0);
    };

    this.scrollToBottom = function () {
        var maxh = $(defargs.element)[0].scrollHeight;
        var oh = $(defargs.element).outerHeight();    
        
        scrollToPosY(maxh-oh);
    };

    this.scrollToLeft = function () {
        scrollToPosX(0);
    };

    this.scrollToRight = function () {
        var maxw = $(defargs.element)[0].scrollWidth;
        var ow = $(defargs.element).outerWidth();
        
        scrollToPosX(maxw-ow);
    };
}

